import classNames from 'classnames';
import useCommon from '@utils/hooks/common';
import Icon from '@ant-design/icons/lib/components/Icon';
import myIconWhite from '@public/images-mobile/game-room/my_icon.svg';
import MyIconBlack from '@public/images-mobile/game-room/my_icon_black.svg';
import styles from './styles';
import PlayerIcon from '@components/PlayerIcon';
import {CSSProperties} from 'react';
import CustomModalSheet from '@components/CustomModalSheet';
import {formatCompactNumber, getOrdinal} from '@utils/index';
import PopupContainer from '@components/layout/PopupContainer';
import GradientButton from '@components/GradientButton';
import {useRouter} from 'next/router';
import {isNil} from 'lodash-es';
// import Poker from '@components/Poker';
// import classnames from 'classnames';

interface TournamentResult {
  rank: number;
  prize: number;
}

interface TournamentResultModalSheetProps {
  isModalSheetOpen: boolean;
  onModalSheetClose: () => void;
  tournamentName: string;
  result: TournamentResult;
  tournamentId: number;
}

const TournamentResultModalSheet = (props: TournamentResultModalSheetProps): JSX.Element => {
  const {isModalSheetOpen, onModalSheetClose, tournamentName, result, tournamentId} = props;
  const {classes, t, system} = useCommon({
    withStyles: {styles, hasProps: true, props},
    withTranslation: ['tournament'],
    observers: ['system'],
  });

  const router = useRouter();

  const seeResults = () => {
    console.log('seeResults');
    router.push({
      pathname: '/tournament',
      query: {
        tournamentId,
        showResult: true,
      },
    });
    system?.hideGameOverlay();
  };

  return (
    <PopupContainer
      visible={isModalSheetOpen}
      onCancel={onModalSheetClose}
      title={
        <div className={classes.title}>
          <img src="/images-mobile/header-mobile/win4poker-horizontal.svg" height={18} alt="logo" />
          {/* Ensure the div always has a minimum height of one line */}
          <div className={classes.tournamentName}>{tournamentName || '\u00A0'}</div>
        </div>
      }
    >
      <div className={classes.container}>
        <div key={result?.rank} className={classNames(classes.resultItem)}>
          <div className={classes.rankContainer}>
            <img height={155} src="/images/tournament/rank_result_decoration.svg" />
            <div className={classes.rankContent}>
              <span className={classes.rank}>{result?.rank}</span>
              <span className={classes.rankSuffix}>{getOrdinal(result?.rank)}</span>
            </div>
          </div>
          <div className={classes.prizeContainer}>
            {result?.prize > 0 ? (
              <>
                <span className={classes.prizeMessageSmall}>{t('congratulations')}</span>
                <span className={classes.prizeMessage}>{t('you_have_won')}</span>
                <span className={classes.prizeAmount}>${formatCompactNumber(result?.prize)}</span>
              </>
            ) : (
              <span className={classes.prizeMessage}>{t('thanks_for_your_joining')}</span>
            )}
            {result?.rank <= 3 ? (
              <span className={classes.medal}>
                {result?.rank === 1 && (
                  <img src="/images/tournament/gold_medal.svg" width={100} height={100} />
                )}
                {result?.rank === 2 && (
                  <img src="/images/tournament/silver_medal.svg" width={100} height={100} />
                )}
                {result?.rank === 3 && (
                  <img src="/images/tournament/bronze_medal.svg" width={100} height={100} />
                )}
              </span>
            ) : null}
          </div>
        </div>
        <div className={classes.bottomSection}>
          {result?.rank >= 3 || isNil(result?.rank) ? (
            <GradientButton
              style={{height: 50}}
              className={classes.closeButton}
              onClick={onModalSheetClose}
              isBlue={false}
            >
              {t('watch')}
            </GradientButton>
          ) : null}
          <GradientButton style={{height: 50}} className={classes.closeButton} onClick={seeResults}>
            {t('see_result')}
          </GradientButton>
        </div>
      </div>
    </PopupContainer>
  );
};

export default TournamentResultModalSheet;
